/** ConfigCat keys — PWS / A/B testing */

export const FF_RPT_PROMOTION_FALL_SALE = "RPT_PROMOTION_FALL_SALE"
export const FF_RPT_PROMOTION_FALL_SALE_ENDS_AT = "RPT_PROMOTION_FALL_SALE__ENDS_AT"

/** Shared defaults for useFeatureFlags (RPT + marketing sale gate). */
export const FALL_SALE_FLAG_DEFAULTS = {
  [FF_RPT_PROMOTION_FALL_SALE]: false,
  [FF_RPT_PROMOTION_FALL_SALE_ENDS_AT]: 0,
}
